import { useIsFocused } from "expo-router/react-navigation";
import { router } from 'expo-router';
import { useLayoutEffect } from 'react';
import { SubmitHandler } from 'react-hook-form';

import { useNpoOnboarding } from '@/api/hooks/meHooks';
import { useUpdateNonProfitOrg } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrg } from '@/api/models/nonProfitOrgModels';
import NpoBackgroundChecksForm from '@/components/forms/NpoBackgroundChecksForm';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { BackgroundChecksData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const BackgroundChecks = () => {
  const { state: authState } = useAuth();
  const { state: npoScreensState, setCurrentPage } = useNpoLoginScreenState();
  const { mutateAsync: onBoardingUpdate, isPending: onBoardingIsPending } = useNpoOnboarding(
    authState.signUpData?.loginEmail?.type ?? 'CHURCH'
  );
  const { mutateAsync: nonProfitUpdate, isPending: nonProfitIsPending } = useUpdateNonProfitOrg();

  const isFocused = useIsFocused();
  useLayoutEffect(() => {
    if (isFocused) authState.signUpData?.loginEmail?.type === 'CHURCH' ? setCurrentPage(3) : setCurrentPage(4);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  const nonProfitOrg = safeJsonParse<NonProfitOrg>(npoScreensState.initialNpoData ?? '');

  const onSubmit: SubmitHandler<BackgroundChecksData> = async (data) => {
    try {
      nonProfitUpdate(
        {
          npoId: authState.signUpData?.loginEmail?.npoId ?? '',
          employees: data.employees,
          volunteers: data.volunteers
        },
        {
          onSuccess: () => {
            onBoardingUpdate(
              {
                preferenceId: authState.preferenceId ?? '',
                backgroundChecks: true
              },
              {
                onSuccess: () => {
                  router.navigate('/(app)/login/nonProfit/onBoarding/boardDirectors');
                }
              }
            );
          },
          onError: (e) => {
            console.error(e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <NpoBackgroundChecksForm
      nonProfitOrg={nonProfitOrg}
      isLoading={onBoardingIsPending || nonProfitIsPending}
      onSubmitTapped={onSubmit}
    />
  );
};

export default BackgroundChecks;
